import React from 'react'
import {
  CFSelect,
  CFView,
  CFImage,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { orderPickupButton } from 'images'
import { dispatch } from 'store'

export default () => {
  return (
    <CFSelect selector={dispatch.restaurant.getSelectedLocationId}>
      {locationId => (
        <CFView>
          <MobileScreen>
            <a
              href={`https://order.codefusion.tech/restaurants/jP5DCERNzu5FHzc23YkX/locations/fH8ufGd34epu9TvdZE1x`}
            >
              <CFView hover>
                <CFImage
                  src={orderPickupButton}
                  w="80%"
                  minWidth="280px"
                  alt="About"
                />
              </CFView>
            </a>
          </MobileScreen>
          <DefaultScreen>
            <a
              href={`https://order.codefusion.tech/restaurants/jP5DCERNzu5FHzc23YkX/locations/fH8ufGd34epu9TvdZE1x`}
            >
              <CFView hover>
                <CFImage src={orderPickupButton} maxWidth="350px" alt="About" />
              </CFView>
            </a>
          </DefaultScreen>
        </CFView>
      )}
    </CFSelect>
  )
}
